module.exports = __webpack_public_path__ + "img/facility.05b161ad.svg";